import script from "./Master.vue?vue&type=script&setup=true&lang=js"
export * from "./Master.vue?vue&type=script&setup=true&lang=js"

import "./Master.vue?vue&type=style&index=0&id=10cd2576&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10cd2576"]])

export default __exports__